const AIRFLOW_3 = 3

export function isAirflow3(airflowVersion) {
    return parseInt(airflowVersion, 10) >= AIRFLOW_3
}

export function buildDagRunUrl({airflowUrl, airflowVersion, dagId, runId, executionDate, includeBaseDate = true}) {
    const encodedDagId = encodeURIComponent(dagId)
    if (isAirflow3(airflowVersion)) {
        const dagUrl = `${airflowUrl}/dags/${encodedDagId}`
        return runId ? `${dagUrl}/runs/${encodeURIComponent(runId)}` : dagUrl
    }
    const baseDate = includeBaseDate ? `&base_date=${encodeURIComponent(executionDate)}` : ''
    return `${airflowUrl}/graph?dag_id=${encodedDagId}&root=&execution_date=${encodeURIComponent(executionDate)}${baseDate}`
}
